import mixpanel from "mixpanel-browser";
import { trackDuration } from ".";
import { getIsOnpremise, isLoggedInUser } from "..";
import getEnv from "../getEnv";
import isMobile from "../isMobile";
import { MIXPANEL_OTHER_EVENTS } from "../mixpanelEvents";
export var trackPageView = function trackPageView(pageName) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  try {
    mixpanel.track_pageview({
      page: pageName,
      deviceType: isMobile() ? "mobile" : "desktop"
    });
    trackDuration(MIXPANEL_OTHER_EVENTS.PAGE_EXIT);
  } catch (e) {
    console.error("Mixpanel not initialized :", e);
  }
};